/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface ApiOrganicoIdunioneByCorpoGet$Params {
    /**
     * Id del corpo per cui ricercare l'unione
     */
    corpoId: number;
}

export function apiOrganicoIdunioneByCorpoGet(
    http: HttpClient,
    rootUrl: string,
    params: ApiOrganicoIdunioneByCorpoGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<number>> {
    const rb = new RequestBuilder(rootUrl, apiOrganicoIdunioneByCorpoGet.PATH, 'get');
    if (params) {
        rb.query('corpoId', params.corpoId, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return (r as HttpResponse<any>).clone({
                body: parseFloat(String((r as HttpResponse<any>).body)),
            }) as StrictHttpResponse<number>;
        }),
    );
}

apiOrganicoIdunioneByCorpoGet.PATH = '/api/organico/idunione-by-corpo';
